import React from "react"
import "./icons.css"

export const HomeIcon = () => {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M38.9839 14.6804C40.2681 15.6751 41.0558 17.1529 41.19 18.761L41.2091 19.1462V34.6885C41.2091 38.6943 38.0447 41.9526 34.0791 42.1635H30.265C28.4422 42.127 26.9683 40.7087 26.8341 38.9262L26.815 38.656V33.1762C26.815 32.5801 26.3722 32.0837 25.78 31.986L25.6075 31.9668H20.4881C19.8766 31.986 19.3783 32.4268 19.3016 33.0018L19.2825 33.1762V38.6387C19.2825 38.7518 19.2614 38.886 19.2441 38.9818L19.225 39.022L19.2039 39.1543C18.9758 40.7854 17.6341 42.0293 15.9666 42.1462L15.7175 42.1635H12.2866C8.28081 42.1635 5.00331 39.022 4.79248 35.0718V19.1462C4.80973 17.5151 5.52081 16.001 6.70915 14.9468L18.65 5.3443C21.0841 3.41038 24.4958 3.33371 27.0047 5.1143L27.3133 5.3443L38.9839 14.6804ZM38.5239 34.9951L38.545 34.6885V19.1635C38.5239 18.3412 38.1808 17.5726 37.5866 16.9996L37.3375 16.7868L25.6458 7.43348C24.1891 6.26431 22.1191 6.20873 20.5858 7.22264L20.2964 7.43348L8.64304 16.8271C7.97413 17.3235 7.57163 18.071 7.47579 18.8568L7.45471 19.1635V34.6885C7.45471 37.2376 9.44804 39.3268 11.98 39.4801H15.7175C16.1391 39.4801 16.5033 39.1946 16.5589 38.7921L16.5991 38.4471L16.6183 38.3493V33.1762C16.6183 31.1254 18.19 29.4579 20.2025 29.3026H25.6075C27.6564 29.3026 29.3239 30.8762 29.4791 32.8887V38.656C29.4791 39.0585 29.7666 39.4054 30.15 39.4801H33.713C36.2814 39.4801 38.3705 37.5079 38.5239 34.9951Z"
        fill="#FFD23F"
      />
    </svg>
  )
}

export const AboutIcon = () => {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.5972 42.1667C14.8076 42.1667 14.0581 42.1054 13.3528 41.9846L12.935 41.906C8.39056 40.9611 5.74939 37.4805 5.74939 32.1828V13.8173C5.74939 13.1771 5.78772 12.5638 5.86439 11.9773C6.53331 6.83104 10.0696 3.83337 15.5972 3.83337H30.4035C36.5291 3.83337 40.1919 7.51337 40.2494 13.6697V13.8173V32.1828C40.2494 38.4254 36.5771 42.1667 30.4035 42.1667H15.5972ZM15.5972 6.62599C10.8899 6.62599 8.50365 9.04674 8.50365 13.8173V32.1828C8.50365 36.9534 10.8899 39.3742 15.5972 39.3742H30.3862C35.0917 39.3742 37.4626 36.9534 37.4626 32.1828V13.8173C37.4626 9.04674 35.0917 6.62599 30.3862 6.62599H15.5972ZM31.2526 31.1152C31.2526 30.3486 30.6412 29.7276 29.886 29.7276H16.0649C15.3098 29.7276 14.6964 30.3486 14.6964 31.1152C14.6964 31.8819 15.3098 32.5029 16.0649 32.5029H29.886C30.6412 32.5029 31.2526 31.8819 31.2526 31.1152ZM29.886 21.6028C30.4131 21.5453 30.9287 21.7983 31.2104 22.2526C31.4922 22.7107 31.4922 23.2895 31.2104 23.7476C30.9287 24.2018 30.4131 24.4548 29.886 24.3973H16.0649C15.3634 24.3168 14.8325 23.7169 14.8325 23.0001C14.8325 22.2833 15.3634 21.6814 16.0649 21.6028H29.886ZM22.572 14.8944C22.572 14.1776 22.0411 13.5758 21.3396 13.4972H16.0821C15.3787 13.5758 14.8478 14.1776 14.8478 14.8944C14.8478 15.6094 15.3787 16.2112 16.0821 16.2898H21.3396C22.0411 16.2112 22.572 15.6094 22.572 14.8944Z"
        fill="#FFD23F"
      />
    </svg>
  )
}

export const BiographyIcon = () => {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.9871 3.83325H14.2845C7.14898 3.83325 3.83331 8.00285 3.83331 15.7711V30.2287C3.83331 37.6358 8.36338 42.1666 15.7723 42.1666H30.1938C37.5885 42.1666 42.1159 37.6332 42.1159 30.2287L42.1666 21.0269C42.1667 13.2685 38.9286 9.47068 31.6816 9.47068H26.4405C25.5488 9.4689 24.7069 9.04739 24.1688 8.33194L22.4788 6.08123C21.4192 4.66659 19.7547 3.83325 17.9871 3.83325ZM14.2845 6.6152H17.9871C18.8802 6.6152 19.7213 7.03627 20.2572 7.75173L21.9488 10.0047C23.0113 11.4173 24.6727 12.2491 26.4378 12.2526L31.6816 12.2526C37.2881 12.2526 39.3884 14.7159 39.3884 21.0192L39.3377 30.221C39.3376 36.0967 36.0541 39.3846 30.1938 39.3846H15.7723C9.89706 39.3846 6.6116 36.0986 6.6116 30.2287V15.7711C6.6116 9.41785 8.84027 6.6152 14.2845 6.6152ZM33.2399 27.8756C33.2399 27.1074 32.6179 26.4846 31.8507 26.4846H14.0817L13.8932 26.4973C13.2151 26.5894 12.6925 27.1714 12.6925 27.8756C12.6925 28.6438 13.3144 29.2666 14.0817 29.2666H31.8507L32.0392 29.2539C32.7173 29.1618 33.2399 28.5798 33.2399 27.8756Z"
        fill="#FFD23F"
      />
    </svg>
  )
}

export const CreditIcon = () => {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.4259 5.39606C5.38872 7.66172 2.24989 15.3443 4.60922 22.6733C5.80646 26.1245 7.75356 29.2263 10.3117 31.7712C13.8211 35.1795 17.6765 38.1789 21.821 40.7275L22.2917 41.0093C22.7424 41.2791 23.3063 41.2744 23.7524 40.9971L24.1918 40.724C28.3306 38.1789 32.186 35.1795 35.6834 31.783C38.2535 29.2263 40.2006 26.1245 41.3879 22.7033C43.7558 15.3488 40.604 7.66253 33.5646 5.39617L33.0554 5.24452C29.8279 4.35683 26.3982 4.79424 23.507 6.43116L22.9931 6.73581L22.4882 6.43286C19.4387 4.70251 15.7941 4.31264 12.4259 5.39606ZM21.8014 9.30411L22.1784 9.57457C22.6755 9.93056 23.3462 9.92348 23.8356 9.55708C26.3848 7.64868 29.6839 7.09333 32.7061 8.06291C38.1602 9.81887 40.6423 15.8719 38.7289 21.8156C37.6911 24.8051 35.9733 27.5418 33.7173 29.7861L32.7053 30.7475C29.9786 33.2814 27.0299 35.5753 23.8991 37.5967L23.0024 38.1606L23.276 38.3331C19.3209 35.9009 15.628 33.0279 12.2778 29.7742C10.0338 27.5418 8.31594 24.8051 7.2681 21.7856C5.36295 15.8663 7.83427 9.81749 13.2854 8.06247C16.1638 7.13659 19.3019 7.59564 21.8014 9.30411ZM30.418 12.4272C29.6805 12.1918 28.8917 12.5984 28.6561 13.3352C28.4205 14.0721 28.8274 14.8603 29.5649 15.0957C31.0144 15.5583 32.0477 16.8629 32.1772 18.4019C32.2421 19.1727 32.92 19.7451 33.6915 19.6803C34.463 19.6155 35.0358 18.9381 34.9709 18.1672C34.7468 15.5032 32.9507 13.2356 30.418 12.4272Z"
        fill="#FFD23F"
      />
    </svg>
  )
}

export const AnalysisIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 23C11.5376 23 14 20.5376 14 17.5C14 14.4624 11.5376 12 8.5 12C5.46243 12 3 14.4624 3 17.5C3 20.5376 5.46243 23 8.5 23Z"
        fill="white"
      />
      <rect x="11" y="4" width="0" height="13" fill="white" />
      <rect x="11" y="1" width="11" height="6" rx="2" fill="white" />
    </svg>
  )
}

export const ResearchIcon = () => {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.60661 26.6718L26.1802 8.4651C28.5699 6.12264 32.4458 6.12264 34.8355 8.4651L37.3163 10.8969C39.706 13.2394 39.706 17.0388 37.3163 19.3813L18.6695 37.6597C17.6033 38.7049 16.1576 39.2914 14.6487 39.2914H7.0122C6.30279 39.2914 5.73272 38.7185 5.7504 38.0233L5.94249 30.47C5.98068 29.0425 6.5766 27.6814 7.60661 26.6718ZM35.5313 12.6466L33.0505 10.2148C31.6467 8.83871 29.3691 8.83871 27.9652 10.2148L26.5233 11.6283L34.0902 19.0442L35.5313 17.6315C36.9352 16.2554 36.9352 14.0227 35.5313 12.6466ZM9.39165 28.4215L24.7383 13.378L32.3052 20.7939L16.8845 35.9099L16.6794 36.094C16.1129 36.5593 15.3951 36.8168 14.6488 36.8168L8.3058 36.816L8.46608 30.5333C8.48729 29.7406 8.81911 28.9827 9.39165 28.4215ZM40.25 38.0544C40.25 37.371 39.6849 36.8171 38.9878 36.8171H25.8194L25.6481 36.8284C25.032 36.9103 24.5572 37.428 24.5572 38.0544C24.5572 38.7377 25.1223 39.2916 25.8194 39.2916H38.9878L39.1591 39.2803C39.7751 39.1984 40.25 38.6807 40.25 38.0544Z"
        fill="#FFD23F"
      />
    </svg>
  )
}

export const PerformanceIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      space="preserve"
      viewBox="0 0 501.321 189.395"
      enable-background="new 0 0 501.321 189.395"
      overflow="visible"
    >
      <g id="Layer_1">
        <g clip-rule="evenodd" fill-rule="evenodd">
          <path
            d="m13.77 144.7c4.769 0 8.64 3.887 8.64 8.676s-3.871 8.678-8.64 8.678c-4.77 0-8.64-3.889-8.64-8.678s3.87-8.68 8.64-8.68"
            fill="#fff"
          />
          <path
            stroke="#000"
            stroke-width=".036"
            stroke-miterlimit="10"
            d="m147.36 8.91l-5.868-3.168c-2.052 2.376-4.752 3.708-8.244 4.14-3.456 0.36-5.148-0.324-12.564-1.764-7.632-1.656-21.636-5.796-32.436-6.984-10.944-1.224-21.924-1.908-31.969 0.468-10.008 2.304-19.692 6.444-27.504 13.824-7.991 7.452-14.867 21.132-19.367 30.348-4.5 8.964-6.336 16.596-7.308 23.868-1.044 7.308-0.577 13.644 1.259 19.548-2.232 1.728-3.348 3.816-3.348 6.66-0.072 2.771 1.044 6.012 3.204 9.865-0.972 6.695 0.252 14.578 3.816 24.336 3.6 9.756 9.684 24.119 17.136 33.371 7.272 9.035 16.344 16.633 26.388 20.988 9.972 4.211 22.572 5.436 33.228 4.932 10.584-0.611 21.708-5.291 30.06-7.813 8.208-2.52 13.752-6.191 19.548-6.984 5.76-0.863 10.692-0.18 14.94 2.053l5.256-3.313c-1.944-1.908-2.952-4.139-3.024-6.84-0.216-2.844-0.072-6.119 2.52-9.395 2.592-3.35 6.696-7.236 12.888-10.01 6.156-2.844 17.064-5.146 23.688-6.336 6.48-1.223 11.088-1.115 14.94-0.504 3.672 0.434 5.76 0.865 7.632 3.816 1.836 2.953 3.096 7.668 3.636 14.148l6.552 3.348c2.232-2.053 4.86-3.492 7.884-4.463 2.88-1.045 4.932-1.656 10.188-1.262 5.22 0.504 13.463 3.168 21.276 3.816 7.775 0.396 17.496 0.721 24.984-0.971 7.416-1.908 13.32-4.572 19.223-9.504 5.725-5.041 11.449-11.484 15.084-19.729 3.529-8.172 5.725-17.785 6.445-28.98l115.74-8.424c3.959-0.612 8.1-1.188 12.563-1.584 4.43-0.504 9.145-0.828 14.148-1.116 0.217 0.9 1.008 1.476 2.52 1.584 1.441 0.108 3.457-0.252 6.193-0.936-0.576 2.556-0.145 4.176 1.295 5.255 1.441 0.938 5.438 1.477 7.129 0.793 1.584-0.756 2.34-2.412 2.412-5.112 2.412 0 4.104-0.468 5.076-1.26 0.936-0.936 1.043-1.98 0.467-3.672 2.377 1.188 4.068 0.972 5.076-0.792 1.008-1.8 1.801-7.812 0.973-9.684-0.936-1.944-3.061-2.484-6.516-1.764 0.035-1.944-0.396-3.132-1.441-3.96-1.08-0.828-2.664-1.044-4.752-0.792 0.252-2.484-0.18-4.104-1.295-5.256-1.225-1.188-3.852-1.656-5.4-1.404-1.619 0.216-3.313 1.62-3.959 2.844-0.686 1.08-0.793 2.592-0.182 4.14-1.979-0.576-3.563-0.684-4.895-0.18-1.369 0.396-2.484 1.404-3.205 2.88 0.469-0.504-2.34-0.828-8.424-0.972-6.191-0.18-15.371-0.18-28.115 0l-107.17 0.54c0.432-4.788-0.434-10.224-2.881-16.704-2.447-6.588-6.336-15.66-11.664-21.78-5.473-6.12-13.104-11.34-20.375-14.292-7.201-3.024-14.725-3.816-22.861-3.492-8.424 0.252-19.764 3.744-26.387 5.076-6.444 1.224-8.64 2.484-12.42 2.232-3.96-0.468-7.668-1.908-11.124-4.608l-6.192 3.96c1.836 3.636 2.232 6.768 1.044 9.684-1.26 2.808-3.276 5.724-8.136 7.344-4.968 1.548-13.572 2.232-20.808 1.908-7.344-0.468-16.308-1.908-22.572-4.608-6.372-2.88-12.42-7.56-14.796-12.096-2.37-4.636-2.15-9.676 0.76-15.292z"
          />
          <path
            stroke="#000"
            stroke-width=".036"
            stroke-miterlimit="10"
            d="m322.07 71.55c0.252-3.24-0.324-7.164-1.584-11.916-1.369-4.896-2.27-10.692-6.193-16.56-4.031-6.012-10.836-14.148-17.496-18.432-6.803-4.176-15.623-6.084-22.572-6.84-7.092-0.828-12.996 0.648-19.223 1.908-6.409 1.152-12.924 4.14-18.145 4.932-5.22 0.576-9.504 0-12.708-0.612-3.276-0.648-5.4-1.512-6.516-2.88l-2.376 1.116c1.152 2.916 1.476 5.436 1.116 7.956-0.396 2.376-0.972 4.644-3.672 6.66-2.952 2.052-7.128 4.608-13.5 5.58-6.552 0.828-16.812 0.9-24.804-0.324-8.028-1.332-17.172-4.104-22.572-7.488-5.364-3.492-8.316-9.036-9.54-13.032-1.368-4.032-0.684-7.632 1.764-10.944l-1.908-1.44c-0.144 2.268-2.772 3.384-8.28 3.348-5.58-0.144-16.56-2.34-24.48-3.816-7.848-1.548-14.904-4.356-22.716-5.112-8.059-0.864-16.23-1.584-24.799 0.18-8.64 1.692-17.388 5.076-26.532 10.152 6.084 4.716 11.016 10.872 14.94 18.468 3.816 7.596 8.604 16.74 8.244 26.856-0.396 10.08-3.996 20.772-10.656 32.904 5.688-3.384 12.204-6.336 20.376-9.396 7.992-3.132 21.276-7.416 27.648-8.568 6.156-1.188 8.244-0.18 10.152 2.052 1.8 2.196 1.116 6.372 1.44 10.98 0.36 4.5 0.576 11.269 0.648 15.876-0.072 4.393 1.044 9.107-0.972 10.836-2.16 1.656-5.292 0.611-11.736-0.504-6.66-1.225-17.532-4.824-27.18-6.336-9.72-1.621-21.6-2.844-30.204-2.701-8.604 0.182-15.552 3.061-20.844 3.637-5.292 0.359-9 0.18-10.98-0.936-1.476 2.699-1.008 7.523 1.116 14.615 2.124 7.057 6.696 19.297 11.772 27.828 5.004 8.461 10.404 16.74 18.288 22.896 7.884 6.047 19.224 11.195 28.764 13.355 9.396 1.943 18.612 0.469 27.648-1.115 9-1.693 19.728-6.301 25.92-8.424 6.012-2.197 6.444-3.637 10.188-4.465 3.672-0.863 8.748-0.828 11.772-0.469 2.844 0.254 4.644 1.045 5.4 2.232l2.52-1.619c-2.052-1.26-3.06-3.168-3.024-5.869-0.108-2.879-0.072-6.516 3.024-10.332 2.952-3.887 7.524-8.783 15.264-11.916 7.848-3.168 23.148-5.902 31.176-6.695 7.884-0.9 12.24-1.477 16.128 1.764 3.78 3.277 5.904 8.928 6.516 17.496l2.52 2.053c2.412-3.061 5.724-4.824 10.332-5.58 4.572-0.721 10.332 0.504 16.848 1.295 6.373 0.721 14.58 2.594 21.312 2.846 6.553 0.143 12.096 0.287 18.432-1.908 6.373-2.377 13.861-6.012 19.549-11.736 5.58-5.939 10.691-15.66 13.535-22.752 2.771-7.02 3.492-13.285 2.701-19.08l-113.51 10.188c1.008-2.809 1.512-6.264 1.908-10.512 0.288-4.393 0.468-9.684 0-14.76-0.576-5.004-1.584-10.044-3.168-15.12 37.61 0.036 75.27 0.108 112.92 0.18z"
            fill="#A16121"
          />
          <path
            stroke="#000"
            stroke-width=".036"
            stroke-miterlimit="10"
            d="m150.25 75.258c1.44-0.612 2.988-0.936 4.5-0.828 1.476-0.036 3.636-0.576 4.68 1.296 0.972 1.908 1.008 5.868 1.368 9.648 0.36 3.6 0.72 7.524 0.648 12.204-0.216 4.715-0.324 13.355-1.836 15.623-1.62 2.018-4.104 0.938-7.596-3.24l0.18-4.104c0.972 0.324 1.656 0.109 2.196-0.936 0.36-1.152 0.576-1.943 0.648-5.148 0.144-3.313 0.288-11.339 0-13.967-0.468-2.628-1.332-2.988-2.592-1.368-0.252-1.98-0.504-3.672-0.9-5.22-0.4-1.619-0.84-2.807-1.3-3.959z"
          />
          <path
            stroke="#000"
            stroke-width=".036"
            stroke-miterlimit="10"
            d="m126.63 139.73l3.204 2.484c2.232-1.477 3.96-1.836 5.58-1.08 1.512 0.646 3.744 3.744 3.636 5.398-0.252 1.621-2.52 4.213-4.572 4.465-2.088 0.145-5.904-1.367-7.704-3.564-1.944-2.34-4.644-6.695-3.384-10.008 1.26-3.564 5.652-7.775 11.088-10.115s14.724-2.773 21.204-3.385c6.408-0.576 12.492-0.035 16.884-0.324 4.212-0.432 6.804-1.152 8.604-2.16 1.764-1.008 2.556-2.375 2.232-3.959l-2.232-1.656c-2.196 0.359-3.708 0.18-4.536-0.684-0.936-0.973-1.656-3.529-0.756-4.465 0.936-1.043 3.744-1.98 5.796-1.152 1.908 0.793 4.932 3.457 5.472 6.193 0.432 2.734-0.324 7.271-2.808 9.863-2.628 2.375-7.344 4.031-12.348 4.969-5.112 0.756-11.664 0.143-17.712 0.504-6.192 0.287-13.752 0.646-18.396 2.051-4.67 1.43-7.62 3.59-9.24 6.61z"
          />
          <path
            stroke="#000"
            stroke-width=".036"
            stroke-miterlimit="10"
            d="m124.79 44.262l3.204-2.484c2.232 1.404 3.96 1.764 5.58 1.08 1.512-0.756 3.744-3.852 3.636-5.4-0.252-1.728-2.52-4.284-4.572-4.464-2.088-0.252-5.904 1.26-7.704 3.564-1.944 2.232-4.644 6.588-3.384 10.008 1.26 3.456 5.652 7.704 11.088 10.116 5.436 2.232 14.724 2.664 21.204 3.384 6.408 0.468 12.492-0.072 16.884 0.324 4.212 0.36 6.804 1.08 8.604 2.16 1.764 0.972 2.556 2.304 2.232 3.996l-2.232 1.656c-2.196-0.468-3.708-0.252-4.536 0.648-0.936 0.864-1.656 3.456-0.756 4.464 0.936 0.972 3.744 1.872 5.796 1.152 1.908-0.9 4.932-3.564 5.472-6.192 0.432-2.808-0.324-7.344-2.808-9.864-2.628-2.484-7.344-4.14-12.348-4.968-5.112-0.828-11.664-0.252-17.712-0.504-6.192-0.396-13.752-0.756-18.396-2.052-4.67-1.476-7.62-3.636-9.24-6.624z"
          />
          <path
            stroke="#000"
            stroke-width=".036"
            stroke-miterlimit="10"
            d="m98.657 80.73l59.724-4.68 281.48-1.98-0.217 2.232-281.27 1.476-59.724 4.428v-1.476z"
          />
          <path
            stroke="#000"
            stroke-width=".036"
            stroke-miterlimit="10"
            d="m99.197 80.946l58.464-4.464 40.428-0.216 241.2-1.836-0.072 1.476-74.16 0.252-207.32 1.26-58.752 4.428 0.209-0.9z"
            fill="#fff"
          />
          <path
            stroke="#000"
            stroke-width=".036"
            stroke-miterlimit="10"
            d="m98.226 110.79l59.976 1.08 281.74-22.211-0.145-1.692-281.74 22.177-59.76-0.504-0.074 1.15z"
          />
          <path
            stroke="#000"
            stroke-width=".036"
            stroke-miterlimit="10"
            d="m98.549 110.47l58.896 1.043 40.32-3.168 241.78-18.97-0.145-1.044-75.238 6.156-206.71 16.092-58.68-0.576-0.221 0.48z"
            fill="#fff"
          />
          <path
            stroke="#000"
            stroke-width=".036"
            stroke-miterlimit="10"
            d="m99.197 99.486l59.976 1.08 279.68-15.192-0.072-1.656-279.76 15.12-59.76-0.504-0.063 1.148z"
          />
          <path
            stroke="#000"
            stroke-width=".036"
            stroke-miterlimit="10"
            d="m99.557 99.125l58.896 1.08 279.97-15.119-0.145-0.936-279.86 15.089-58.68-0.576-0.183 0.467z"
            fill="#fff"
          />
          <path
            stroke="#000"
            stroke-width=".036"
            stroke-miterlimit="10"
            d="m99.666 90.414l59.76-0.684 279.5-9.144 0.035-1.584-279.68 9.036-59.652 1.26 0.038 1.116z"
          />
          <path
            stroke="#000"
            stroke-width=".036"
            stroke-miterlimit="10"
            d="m99.989 90.162l58.68-0.792 279.83-9.18v-0.864l-279.83 9.108-58.644 1.08-0.041 0.648z"
            fill="#fff"
          />
          <path
            stroke="#000"
            stroke-width=".036"
            stroke-miterlimit="10"
            d="m102.87 79.362c-0.576 0.036-1.296 0.036-2.16 0.144-0.936 0.108-2.016 0.18-3.24 0.36-0.468-0.396-0.972-0.54-1.368-0.432-0.468 0.072-0.9 0.468-1.152 0.9-0.288 0.36-0.864 0.756-0.612 1.332 0.108 0.468 0.576 1.008 1.404 1.62-0.468-0.036-1.008-0.36-1.332-0.684-0.468-0.504-1.044-1.044-1.044-1.62-0.108-0.648 0.612-1.368 1.044-1.764 0.432-0.504 0.9-0.576 1.548-0.612 0.504-0.072 1.224 0.288 1.872 0.684 1.655 0 3.35 0.036 5.04 0.072z"
            fill="#fff"
          />
          <path
            stroke="#000"
            stroke-width=".036"
            stroke-miterlimit="10"
            d="m103.01 87.714c-0.576 0-1.296 0.108-2.16 0.18-0.936 0.108-2.016 0.18-3.24 0.36-0.504-0.432-0.9-0.54-1.332-0.468-0.432 0.108-0.972 0.36-1.188 0.9-0.288 0.36-0.864 0.756-0.612 1.332 0.108 0.468 0.576 1.008 1.404 1.62-0.468-0.072-1.008-0.288-1.332-0.648-0.468-0.396-1.08-1.116-1.008-1.62-0.072-0.612 0.54-1.44 1.008-1.8 0.396-0.432 0.972-0.576 1.584-0.576 0.54-0.036 1.152 0.18 1.836 0.648 1.659 0 3.35 0.036 5.04 0.072z"
            fill="#fff"
          />
          <path
            stroke="#000"
            stroke-width=".036"
            stroke-miterlimit="10"
            d="m102.36 97.146c-0.504-0.072-1.26-0.037-2.124-0.037-0.936 0-1.98 0.037-3.276 0.109-0.468-0.434-0.9-0.613-1.296-0.541-0.504 0.037-0.972 0.396-1.26 0.793-0.324 0.287-0.936 0.756-0.72 1.26 0.072 0.504 0.504 1.043 1.296 1.764-0.504-0.18-0.936-0.396-1.296-0.793-0.432-0.539-1.008-1.15-0.9-1.691 0-0.684 0.72-1.295 1.188-1.691 0.396-0.324 0.972-0.612 1.584-0.469 0.54 0.107 1.188 0.252 1.8 0.828 1.658 0.148 3.31 0.293 5 0.472z"
            fill="#fff"
          />
          <path
            stroke="#000"
            stroke-width=".036"
            stroke-miterlimit="10"
            d="m101.61 108.88c-0.504-0.182-1.26-0.145-2.124-0.289-0.936-0.145-1.98-0.252-3.276-0.324-0.432-0.539-0.792-0.648-1.224-0.719-0.468-0.037-1.008 0.215-1.332 0.611-0.36 0.252-0.972 0.648-0.864 1.188 0.072 0.469 0.288 1.152 1.044 1.908-0.468-0.18-0.9-0.539-1.152-0.936-0.36-0.576-0.864-1.225-0.684-1.801 0.108-0.648 0.792-1.26 1.368-1.547 0.432-0.252 1.08-0.469 1.656-0.252 0.468 0.18 1.152 0.395 1.656 1.043 1.619 0.36 3.276 0.73 4.932 1.12z"
            fill="#fff"
          />
          <path
            stroke="#000"
            stroke-width=".036"
            stroke-miterlimit="10"
            d="m432.41 71.91l-0.109-12.348c-0.719-0.432-0.898-0.9-0.936-1.26 0.072-0.36 0.289-0.756 1.045-1.044 0.215-0.936-0.072-1.548-0.469-1.98-0.576-0.504-1.584-0.108-2.447-0.612-1.008-0.576-2.305-1.548-2.773-2.772-0.576-1.368-0.863-3.276 0.109-5.148 1.008-2.016 3.744-5.04 5.832-6.156 1.979-1.188 3.779-1.152 5.795-0.468 1.836 0.72 4.393 2.556 5.58 4.536 1.08 1.764 1.764 4.716 1.08 6.516-0.863 1.764-4.68 3.132-5.615 4.104-0.9 0.828-0.9 1.296 0.143 1.26 0.252 0.18 0.361 0.54 0.324 0.936-0.107 0.36-0.324 0.864-0.791 1.512l0.107 12.096c-2.24 0.252-4.54 0.54-6.85 0.828z"
          />
          <path
            stroke="#000"
            stroke-width=".036"
            stroke-miterlimit="10"
            d="m451.49 71.334v-14.22c0.611-0.648 0.863-1.224 0.611-1.728-0.289-0.576-1.08-1.08-2.232-1.512 1.045-1.476 1.691-3.168 2.088-5.364 0.289-2.16-0.504-6.156 0-7.56 0.432-1.62 1.656-1.476 2.701-1.512 0.936-0.18 2.412-0.072 2.916 1.152 0.215 1.26-0.865 3.816-0.613 6.156 0.289 2.196 1.152 4.572 2.592 7.128-0.646 0.324-1.043 0.756-1.188 1.152s-0.107 0.864 0.252 1.404v14.652l-6.299 0.576-0.83-0.324z"
          />
          <path
            stroke="#000"
            stroke-width=".036"
            stroke-miterlimit="10"
            d="m442.31 90.162v14.221c0.648 0.611 0.793 1.188 0.576 1.727-0.324 0.541-1.008 1.045-2.195 1.512 1.045 1.441 1.691 3.133 2.088 5.365 0.287 2.051-0.504 6.047 0 7.559 0.324 1.514 1.764 1.369 2.664 1.514 0.936 0.072 2.412-0.037 2.916-1.152 0.324-1.369-0.936-3.924-0.576-6.156 0.289-2.232 1.188-4.607 2.557-7.129-0.613-0.359-1.045-0.791-1.152-1.15-0.18-0.434-0.107-0.9 0.217-1.404v-14.646l-6.266-0.612-0.84 0.36z"
          />
          <path
            stroke="#000"
            stroke-width=".036"
            stroke-miterlimit="10"
            d="m457.9 88.218l-0.107 12.349c-0.719 0.395-0.9 0.863-0.936 1.26 0.072 0.396 0.287 0.756 1.043 1.08 0.217 0.9-0.07 1.512-0.467 1.98-0.576 0.432-1.584-0.072-2.449 0.574-1.008 0.469-2.303 1.441-2.771 2.773-0.576 1.26-0.863 3.203 0.109 5.148 1.008 1.906 3.742 4.932 5.832 6.154 1.979 1.117 3.779 1.045 5.795 0.469 1.908-0.828 4.428-2.664 5.615-4.535 1.152-1.873 1.693-4.789 1.045-6.518-0.756-1.799-4.752-3.203-5.58-4.066-0.973-0.938-0.936-1.369 0.107-1.297 0.324-0.217 0.396-0.576 0.361-0.936-0.072-0.432-0.396-0.936-0.828-1.512l0.107-12.097c-2.26-0.229-4.57-0.517-6.87-0.805z"
          />
        </g>
      </g>
    </svg>
  )
}

export const Logo = () => {
  return (
    <div id="logo">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className="logo-line"
          d="M16 18C14.423 18 12.9466 17.3826 11.8512 16.3346"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          className="logo-line"
          d="M7.15475 8.05196C5.78876 6.76008 3.95637 6 2 6"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.6432 19.0439C23.2699 18.6522 23.2699 17.7396 22.6432 17.3479L17.53 14.1521C16.864 13.7359 16 14.2147 16 15.0001V21.3916C16 22.1771 16.864 22.6559 17.53 22.2396L22.6432 19.0439Z"
          fill="white"
        />
        <path
          d="M16 6V6C13.5778 6 11.3932 7.45643 10.4615 9.69231L8.92308 13.3846C7.75856 16.1795 5.02776 18 2 18V18"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          className="logo-line"
          stroke-linejoin="round"
        />
        <path
          d="M21.6432 7.04388C22.2699 6.65222 22.2699 5.73956 21.6432 5.34789L16.53 2.15214C15.864 1.73586 15 2.2147 15 3.00013V9.39164C15 10.1771 15.864 10.6559 16.53 10.2396L21.6432 7.04388Z"
          fill="white"
        />
      </svg>
    </div>
  )
}
